import { render, staticRenderFns } from "./DashboardCollapse.vue?vue&type=template&id=18aa025c&scoped=true&"
import script from "./DashboardCollapse.vue?vue&type=script&lang=js&"
export * from "./DashboardCollapse.vue?vue&type=script&lang=js&"
import style0 from "./DashboardCollapse.vue?vue&type=style&index=0&id=18aa025c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18aa025c",
  null
  
)

export default component.exports